import React, { useState } from 'react';
import FeedbackForm from '../Feedback/FeedbackForm';
import { feedbackForms } from '../../config/feedbackQuestions';
import './FeedbackModal.css';

interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
}

type ModalState = 'form' | 'success' | 'error';

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  isOpen,
  onClose
}) => {
  const [currentState, setCurrentState] = useState<ModalState>('form');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  if (!isOpen) return null;

  const handleSubmitSuccess = (response: any) => {
    setSuccessMessage('Feedback submitted successfully! Thank you for helping us improve.');
    setCurrentState('success');
    
    // Auto-close after 2 seconds
    setTimeout(() => {
      onClose();
      resetModal();
    }, 2000);
  };

  const handleSubmitError = (error: string) => {
    setErrorMessage(error);
    setCurrentState('error');
  };

  const resetModal = () => {
    setCurrentState('form');
    setSuccessMessage('');
    setErrorMessage('');
  };

  const handleClose = () => {
    onClose();
    setTimeout(resetModal, 300);
  };

  const renderForm = () => (
    <div className="dark-feedback-modal">
      <FeedbackForm
        form={feedbackForms.general}
        onSubmitSuccess={handleSubmitSuccess}
        onSubmitError={handleSubmitError}
        onClose={handleClose}
      />
    </div>
  );

  const renderSuccess = () => (
    <div className="dark-feedback-modal">
      <div className="status-container success">
        <div className="status-icon">⚡</div>
        <h2 className="status-title">Transmission Complete</h2>
        <p className="status-message">{successMessage}</p>
      </div>
    </div>
  );

  const renderError = () => (
    <div className="dark-feedback-modal">
      <div className="status-container error">
        <div className="status-icon">⚠️</div>
        <h2 className="status-title">Transmission Failed</h2>
        <p className="status-message">{errorMessage}</p>
        <div className="error-actions">
          <button className="btn btn-primary" onClick={() => setCurrentState('form')}>
            Retry
          </button>
          <button className="btn btn-secondary" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (currentState) {
      case 'form':
        return renderForm();
      case 'success':
        return renderSuccess();
      case 'error':
        return renderError();
      default:
        return renderForm();
    }
  };

  return (
    <div 
      className="feedback-modal-overlay dark"
      onClick={handleClose}
    >
      <div 
        className="feedback-modal dark"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-button dark"
          onClick={handleClose}
          aria-label="Close modal"
        >
          ×
        </button>

        {renderContent()}
      </div>
    </div>
  );
};

export default FeedbackModal;
